import React, { useEffect, useState } from 'react';
import * as actionCreators from './../../actions';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, Fade, Modal } from 'react-bootstrap';
import { getAge, handleKeyPress, validateDate } from '../../utilities';
import Inputs from '../../Components/Inputs';


export function TecnologyData({
  codpmpol,
  firstStep,
  titularData,
  tecnologyData,
  setLoading,
  resetData,
  handleChange,
  saveTecnologyData,
  saveError,
}) {
  const { name, lastname, modelo, dni, marca, birthdate } = tecnologyData;
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [legal, setLegal] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    resetData();
    navigate("/");
    setShow(false);
  };

  const redireccion = () => navigate('/qs/payMethod');

  const verifyForm = () => {
    if (firstStep.codsec === 161) {
      if (saveError.details.includes(tecnologyData.dni)) {
        setMensaje('Este DNI ya está registrado')
        return false;
      }
    }
    if (firstStep.codsec === 159) {
      if (saveError.details.includes(`${tecnologyData.marca} ${tecnologyData.modelo}`)) {
        setMensaje('Esta combinacion de marca/modelo ya está registrada')
        return false;
      }
    }
    if (firstStep.codsec === 159) {
      if (!marca || marca.length < 2) {
        setMensaje('Revise la marca')
        return false;
      };
      if (!modelo || modelo.length < 2) {
        setMensaje('Revise el modelo')
        return false;
      };
    }
    if (!name || name.length < 2) {
      setMensaje('Revise el nombre')
      return false;
    };
    if (!lastname || lastname.length < 2) {
      setMensaje('Revise el apellido')
      return false;
    };
    if (!dni || dni.length < 7 || dni.length > 8) {
      setMensaje('Revise el DNI')
      return false;
    };
    if (!birthdate) {
      setMensaje('Revise el DNI')
      return false;
    };
    if (birthdate) {
      if (!validateDate(birthdate)) {
        setMensaje('Revise su fecha de nacimiento');
        return false;
      }
    } else {
      setMensaje('Ingrese su fecha de nacimiento');
      return false;
    }
    if (!legal && getAge(birthdate) >= 18) {
      setMensaje('Indicar los datos del hijo menor de 18 años que usará el producto');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (verifyForm()) {
      setError(false);
      setLoading();
      await saveTecnologyData(tecnologyData, codpmpol);
      redireccion();
    } else {
      setError(true);
    };
  };

  useEffect(() => {
    if (legal) {
      handleChange({ step: "tecnologyData", target: { name: 'name', value: titularData.name } });
      handleChange({ step: "tecnologyData", target: { name: 'lastname', value: titularData.lastname } });
      handleChange({ step: "tecnologyData", target: { name: 'dni', value: firstStep.dni } });
      handleChange({ step: "tecnologyData", target: { name: 'birthdate', value: firstStep.birthday } });
    } else {
      handleChange({ step: "tecnologyData", target: { name: 'name', value: "" } });
      handleChange({ step: "tecnologyData", target: { name: 'lastname', value: "" } });
      handleChange({ step: "tecnologyData", target: { name: 'dni', value: "" } });
      handleChange({ step: "tecnologyData", target: { name: 'birthdate', value: "" } });
    }
  }, [legal])

  useEffect(() => {
    if (codpmpol === "") {
      setShow(true);
    }
  }, []);

  return (
    <div>
      <Fade appear in>
        <div className={`qs ${legal && "qsmargin"}`}>
          <div className="container max-shadow">
            <div className='d-flex flex-column m-0 mx-0 mb-4 scroll-off'>
                <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>DATOS EXTRAS</h1>
                <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
              </div>
            <div className="qs-inputs row row-cols-2">
              {firstStep.codsec === 159 ?
                <>
                  <Inputs
                    title={"Marca"}
                    name={'marca'}
                    step={'tecnologyData'}
                    value={tecnologyData.marca}
                  />
                  <Inputs
                    title={"Modelo"}
                    name={'modelo'}
                    step={'tecnologyData'}
                    value={tecnologyData.modelo}
                  />
                </>
                :
                <>
                  <div className='benef' onClick={() => setLegal(true)}>
                    <input type={'radio'} name="legacy" checked={legal} />
                    <h2>El usuario de los productos a riesgo es el titular</h2>
                  </div>
                  <div className='benef' onClick={() => setLegal(false)}>
                    <input type={'radio'} name="legacy" checked={!legal} />
                    <h2>Agregar asegurado</h2>
                  </div>
                  {!legal &&
                    <>
                      <Inputs
                        title={"Nombre"}
                        name={'name'}
                        step={'tecnologyData'}
                        value={tecnologyData.name}
                      />
                      <Inputs
                        title={"Apellido"}
                        name={'lastname'}
                        step={'tecnologyData'}
                        value={tecnologyData.lastname}
                      />
                      <Inputs
                        title={"DNI"}
                        name={'dni'}
                        type={'number'}
                        onKeyPress={handleKeyPress}
                        step={'tecnologyData'}
                        value={tecnologyData.dni}
                      />
                      <Inputs
                        title={"Fecha de nacimiento"}
                        name={'birthdate'}
                        type={'date'}
                        step={'tecnologyData'}
                        value={tecnologyData.birthdate}
                      />   
                    </>
                  }
                </>
              }
            </div>
            <div>
              {
                error &&
                <Alert className='mt-2' variant={'danger'}>
                  {mensaje}
                </Alert>
              }
            </div>
            <div className='row flexend'>
              <div className="col-sm-6 col-lg-4 offset-lg-4">
                <Inputs
                  type={'button'}
                  title="Continuar"
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>¡Aviso!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Hubo un error en su solicitud, por favor vuelva a intentarlo.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="main-btn">
            Entiendo
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
};

function mapStateToProps(state) {
  return {
    titularData: state.mainReducer.titularData,
    firstStep: state.mainReducer.firstStep,
    tecnologyData: state.mainReducer.tecnologyData,
    codpmpol: state.mainReducer.codpmpol,
    user: state.mainReducer.user,
    loading: state.mainReducer.loading,
    saveError: state.mainReducer.saveError,
  }
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TecnologyData);